import React, { useState, useEffect } from 'react';

import { Statistic, Tooltip, Modal, Badge } from 'antd';

import '../../../less/StationDashboardOverviewInputCard.less';

export default function StationDashboardOverviewInputCard(props) {
  const {
    title,
    className,
    suffix='',
    min,
    max,
    value,
    targetValue,
    safePercent,
    even=false,
    formatter=(value) => value,
    statusFormatter=null,
  } = props;

  const [modalVisible, setModalVisible] = useState(false);

  let status = '';

  const range = max - min;
  const targetPercent = targetValue / range;

  const labels = {
    'danger': [],
    'warning': [],
    'safe': [],
  };

  const clamp = (value) => Math.max(min, Math.min(value, max));

  const hasTargetValue = !isNaN(max) && !isNaN(min) && !isNaN(safePercent) && !isNaN(targetValue);

  if (hasTargetValue) {
    const targetLowerWarningValue = clamp(targetValue - range * safePercent);
    const targetLowerSafeValue = clamp(targetValue - range * safePercent / 2);
    const targetUpperSafeValue = clamp(targetValue + range * safePercent / 2);
    const targetUpperWarningValue = clamp(targetValue + range * safePercent);

    if (!statusFormatter) {
      if (value < targetLowerWarningValue || value > targetUpperWarningValue) {
        status = 'danger';
      } else if (value < targetLowerSafeValue || value > targetUpperSafeValue) {
        status = 'warning';
      } else {
        status = 'safe';
      }
    }

    const decimal = Math.max(0, 2 - Math.floor(Math.log(max) / Math.log(10)));

    if (targetLowerWarningValue.toFixed(decimal) !== min.toFixed(decimal)) {
      labels['danger'].push(`< ${targetLowerWarningValue.toFixed(decimal)}`);
    }
    if (targetLowerSafeValue.toFixed(decimal) !== targetLowerWarningValue.toFixed(decimal)) {
      labels['warning'].push(`${targetLowerWarningValue.toFixed(decimal)} - ${targetLowerSafeValue.toFixed(decimal)}`);
    }
    if (targetUpperSafeValue.toFixed(decimal) !== targetLowerSafeValue.toFixed(decimal)) {
      labels['safe'].push(`${targetLowerSafeValue.toFixed(decimal)} - ${targetUpperSafeValue.toFixed(decimal)}`);
    }
    if (targetUpperWarningValue.toFixed(decimal) !== targetUpperSafeValue.toFixed(decimal)) {
      labels['warning'].push(`${targetUpperSafeValue.toFixed(decimal)} - ${targetUpperWarningValue.toFixed(decimal)}`);
    }
    if (max.toFixed(decimal) !== targetUpperWarningValue.toFixed(decimal)) {
      labels['danger'].push(`> ${targetUpperWarningValue.toFixed(decimal)}`);
    }
  }

  if (statusFormatter) {
    status = statusFormatter(value);
  }

  return (
    <>
      <div
        className={[
          'overview-input-card',
          hasTargetValue ? 'clickable' : null,
          className,
        ].join(' ')}
        onClick={() => setModalVisible(true)}
      >
        <Statistic
          title={title}
          value={formatter(value)}
          suffix={suffix}
          groupSeparator=""
          className={[
            status,
          ].join(' ')}
        />
        <div className="icon" />
      </div>

      {hasTargetValue && (
        <Modal
          title={title}
          visible={modalVisible}
          onCancel={() => setModalVisible(false)}
          width={400}
          maskClosable
          footer={null}
        >
          <div style={{
            display: 'flex',
            justifyContent: 'center',
          }}>
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              width: '100%',
              maxWidth: '60%',
            }}>
              {labels['danger'].length > 0 && (
                <Badge status="error" text={labels['danger'].join(' or ')} />
              )}
              {labels['warning'].length > 0 && (
                <Badge status="warning" text={labels['warning'].join(' or ')} />
              )}
              {labels['safe'].length > 0 && (
                <Badge status="success" text={labels['safe'].join(' or ')} />
              )}
            </div>
          </div>
        </Modal>
      )}
    </>
  );
};
